import { api } from "./client";

export type ClassSuggestion = {
  class: number;
  heading?: string;
  confidence: "high" | "medium" | "low";
  reasoning: string;
};

export type ClassifyResponse = {
  classes: ClassSuggestion[];
  notes?: string;
};

export async function classify(description: string): Promise<ClassifyResponse> {
  const { data } = await api.post<ClassifyResponse>("/classify", { description });
  return data;
}
